module.exports = __webpack_public_path__ + "static/columbus-3db1cd452265ba7ebc5777dbca9c3681.png";